import { sum } from '../helpers/util.js';
export function createTotalWidthCalculator({ getItemWidth, outerFrameWidth, }) {
    return function widthCalculator(items) {
        const itemWidths = items.map(getItemWidth);
        const contentWidth = sum(itemWidths);
        return outerFrameWidth + contentWidth;
    };
}
